// Note: The first file of a module here, must also register the module

import "./declined.component";
import "./privacy-dashboard.component";
import "./privacy-notice-form.component";
import "./privacy-notice-list.component";
import "./privacy-notice-view.component";
import "./user-privacy-notice.component";
